import type { SVGProps } from "react";
export const Call = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M19.575 20.5C17.6327 20.5 15.6983 20.0676 13.772 19.2028C11.8458 18.3381 10.0847 17.1077 8.4885 15.5115C6.89883 13.9153 5.67 12.1535 4.802 10.226C3.934 8.2985 3.5 6.36483 3.5 4.425V3.5H8.66925L9.55575 8.05375L6.78275 10.7462C7.19425 11.4667 7.63458 12.1363 8.10375 12.7548C8.57308 13.3734 9.06925 13.9392 9.59225 14.452C10.1013 14.9738 10.6673 15.4668 11.2905 15.9308C11.9135 16.3949 12.6064 16.8411 13.3693 17.2693L16.125 14.4655L20.5 15.3558V20.5H19.575ZM6.073 9.327L7.94425 7.54225L7.44225 5H5.0155C5.06667 5.75633 5.18042 6.49258 5.35675 7.20875C5.53308 7.92475 5.77183 8.63083 6.073 9.327ZM14.773 17.9693C15.414 18.2654 16.0977 18.4984 16.824 18.6683C17.5503 18.8381 18.2757 18.9384 19 18.9693V16.5673L16.6307 16.0922L14.773 17.9693Z"
			fill="currentColor"
		/>
	</svg>
);
